import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import ApprovalCard from "@/components/ApprovalCard";

export default function ApprovalsPage() {
  const { data: approvals = [], isLoading } = useQuery({
    queryKey: ["approvals"], queryFn: async () => (await api.get("/approvals")).data,
  });

  return (
    <div className="space-y-6" data-testid="approvals-page">
      <div>
        <div className="label-eyebrow text-primary">Verification</div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Pending Approvals</h1>
        <p className="text-muted-foreground mt-1">Finalise captain submissions to push them live to clients.</p>
      </div>

      {isLoading && <p className="text-muted-foreground">Loading…</p>}
      {!isLoading && approvals.length === 0 && (
        <div className="rounded-lg border border-dashed border-border p-12 text-center text-muted-foreground" data-testid="approvals-empty">
          The queue is clear. No updates awaiting review.
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {approvals.map((u) => <ApprovalCard key={u.id} update={u} />)}
      </div>
    </div>
  );
}
